import { STEPS } from '../../redux/modules/teamOnboarding'
import { pushSnowplow, toTeamsFeatureSchema } from '../snowplow'
import { ACTION_TARGETS, ACTION_TARGET_TYPES, ACTION_TYPES, VIEWS, VIEW_TYPES } from './teamsEvents'

export const publishViewedHomePromo = () =>
  pushSnowplow(toTeamsFeatureSchema(VIEWS.HOME_PROMO, VIEW_TYPES.COMPONENT, ACTION_TYPES.VIEWED))

export const publishClickedJoinOrCreateTeam = () =>
  pushSnowplow(
    toTeamsFeatureSchema(
      VIEWS.HOME_PROMO,
      VIEW_TYPES.COMPONENT,
      ACTION_TYPES.CLICKED,
      ACTION_TARGETS.JOIN_OR_CREATE,
      ACTION_TARGET_TYPES.BUTTON,
    ),
  )

export const publishViewedHomeTeam = () =>
  pushSnowplow(toTeamsFeatureSchema(VIEWS.HOME_TEAM, VIEW_TYPES.COMPONENT, ACTION_TYPES.VIEWED))

export const publishClickedHomeInviteMembers = () =>
  pushSnowplow(
    toTeamsFeatureSchema(
      VIEWS.HOME_TEAM,
      VIEW_TYPES.COMPONENT,
      ACTION_TYPES.CLICKED,
      ACTION_TARGETS.INVITE_MEMBERS,
      ACTION_TARGET_TYPES.BUTTON,
    ),
  )

export const publishViewedCreateJoinDialog = () =>
  pushSnowplow(
    toTeamsFeatureSchema(VIEWS.CREATE_JOIN_PROMO, VIEW_TYPES.DIALOG, ACTION_TYPES.VIEWED),
  )

export const publishViewedPotentialTeams = () =>
  pushSnowplow(toTeamsFeatureSchema(VIEWS.POTENTIAL_TEAMS, VIEW_TYPES.LIST, ACTION_TYPES.VIEWED))

export const publishClickedCreateTeamButton = () =>
  pushSnowplow(
    toTeamsFeatureSchema(
      VIEWS.CREATE_JOIN_PROMO,
      VIEW_TYPES.DIALOG,
      ACTION_TYPES.CLICKED,
      ACTION_TARGETS.CREATE_TEAM,
      ACTION_TARGET_TYPES.BUTTON,
    ),
  )

export const publishViewedTeamNameStep = () =>
  pushSnowplow(toTeamsFeatureSchema(VIEWS.STEP_NAME, VIEW_TYPES.DIALOG, ACTION_TYPES.VIEWED))

export const publishChangedTeamName = (input, error) =>
  pushSnowplow(
    toTeamsFeatureSchema(
      VIEWS.STEP_NAME,
      VIEW_TYPES.DIALOG,
      ACTION_TYPES.CHANGED,
      ACTION_TARGETS.TEAM_NAME,
      ACTION_TARGET_TYPES.INPUT,
      input,
      error,
    ),
  )

export const publishClickedNext = (view, error, value = undefined) =>
  pushSnowplow(
    toTeamsFeatureSchema(
      view,
      VIEW_TYPES.DIALOG,
      ACTION_TYPES.CLICKED,
      ACTION_TARGETS.NEXT,
      ACTION_TARGET_TYPES.BUTTON,
      value,
      error,
    ),
  )

export const publishClickedClose = view =>
  pushSnowplow(
    toTeamsFeatureSchema(
      view,
      VIEW_TYPES.DIALOG,
      ACTION_TYPES.CLICKED,
      ACTION_TARGETS.CLOSE,
      ACTION_TARGET_TYPES.BUTTON,
    ),
  )

export const publishViewedDomainStep = () =>
  pushSnowplow(toTeamsFeatureSchema(VIEWS.STEP_DOMAIN, VIEW_TYPES.DIALOG, ACTION_TYPES.VIEWED))

export const publishChangedDomain = (input, error) =>
  pushSnowplow(
    toTeamsFeatureSchema(
      VIEWS.STEP_DOMAIN,
      VIEW_TYPES.DIALOG,
      ACTION_TYPES.CHANGED,
      ACTION_TARGETS.EMAIL_DOMAIN,
      ACTION_TARGET_TYPES.INPUT,
      input,
      error,
    ),
  )

export const publishChangedJoinabilitySetting = checked =>
  pushSnowplow(
    toTeamsFeatureSchema(
      VIEWS.STEP_DOMAIN,
      VIEW_TYPES.DIALOG,
      ACTION_TYPES.CHANGED,
      ACTION_TARGETS.JOINABILITY_SETTING,
      ACTION_TARGET_TYPES.CHECKBOX,
      checked,
    ),
  )

export const publishViewedInviteMembers = () =>
  pushSnowplow(toTeamsFeatureSchema(VIEWS.STEP_INVITE, VIEW_TYPES.DIALOG, ACTION_TYPES.VIEWED))

export const publishClickedAddAnother = () =>
  pushSnowplow(
    toTeamsFeatureSchema(
      VIEWS.STEP_INVITE,
      VIEW_TYPES.DIALOG,
      ACTION_TYPES.CLICKED,
      ACTION_TARGETS.ADD_ANOTHER,
      ACTION_TARGET_TYPES.BUTTON,
    ),
  )

export const publishChangedMemberEmail = (input, error) =>
  pushSnowplow(
    toTeamsFeatureSchema(
      VIEWS.STEP_INVITE,
      VIEW_TYPES.DIALOG,
      ACTION_TYPES.CHANGED,
      ACTION_TARGETS.EMAIL_ADDRESS,
      ACTION_TARGET_TYPES.INPUT,
      input,
      error,
    ),
  )

// ------------------------------------
// Utils
// ------------------------------------
export const getViewByStep = step => {
  switch (step) {
    case STEPS.CREATE_OR_JOIN:
      return VIEWS.CREATE_JOIN_PROMO
    case STEPS.TEAM_NAME:
      return VIEWS.STEP_NAME
    case STEPS.TEAM_DOMAIN:
      return VIEWS.STEP_DOMAIN
    case STEPS.TEAM_MEMBERS:
      return VIEWS.STEP_INVITE
    default:
      console.error('Invalid step name.')
  }
}
